// Enable menu tags - DESKTOP

        document.addEventListener('DOMContentLoaded', function () {
            // Get all elements containing the text '&lt;new&gt;'
            const elements = document.querySelectorAll('.m-menu__link--main, .m-menu__link');
            
            elements.forEach(function(element) {
                // Replace '&lt;new&gt;' with '<span class="newTag">new</span>'
                element.innerHTML = element.innerHTML.replace(/\/\/new\/\//g, '<span class="newTag">NEW </span>');
            });
        });

      document.addEventListener('DOMContentLoaded', function () {
            // Get all elements containing the text '&lt;new&gt;'
            const elements = document.querySelectorAll('.m-menu__link--main, .m-menu__link');
            
            elements.forEach(function(element) {
                // Replace '&lt;new&gt;' with '<span class="newTag">new</span>'
                element.innerHTML = element.innerHTML.replace(/\/\/trending\/\//g, '<span class="trendingTag">HOT</span>');
            });
        });

// enable menu tags - mobile

document.addEventListener('DOMContentLoaded', function () {
            // Get all elements containing the text '&lt;new&gt;'
            const elements = document.querySelectorAll('.m-menu-mobile__link');
            
            elements.forEach(function(element) {
                // Replace '&lt;new&gt;' with '<span class="newTag">new</span>'
                element.innerHTML = element.innerHTML.replace(/\/\/new\/\//g, '<span class="newTag">NEW </span>');
            });
        });

        document.addEventListener('DOMContentLoaded', function () {
            // Get all elements containing the text '&lt;new&gt;'
            const elements = document.querySelectorAll('.m-menu-mobile__back-button');
            
            elements.forEach(function(element) {
                // Replace '&lt;new&gt;' with '<span class="newTag">new</span>'
                element.innerHTML = element.innerHTML.replace(/\/\/new\/\//g, '<span class="newTag">NEW </span>');
            });
        });

document.addEventListener('DOMContentLoaded', function () {
            // Get all elements containing the text '&lt;new&gt;'
            const elements = document.querySelectorAll('.list-none a');
            
            elements.forEach(function(element) {
                // Replace '&lt;new&gt;' with '<span class="newTag">new</span>'
                element.innerHTML = element.innerHTML.replace(/\/\/new\/\//g, '<span class="newTag">NEW </span>');
            });
        });

document.addEventListener('DOMContentLoaded', function () {
    // Get all elements containing the text '&lt;new&gt;'
    const elements = document.querySelectorAll('.m-menu-mobile__link');
    
    elements.forEach(function(element) {
        // Replace '&lt;new&gt;' with '<span class="newTag">new</span>'
        element.innerHTML = element.innerHTML.replace(/\/\/trending\/\//g, '<span class="trendingTag">HOT</span>');
    });
});





// // FREE GIFT SCRIPT

// (function () {
//   const THRESHOLD = 99900; // ₹999 in paise
//   const GIFT_VARIANT_ID = 47748226515093; // Cap variant ID

//   let syncingGift = false;
//   let addingGift = false;
//   let syncTimeout = null;

//   /**
//    * Get current Shopify cart
//    */
//   async function getCart() {
//     const response = await fetch('/cart.js', {
//       method: 'GET',
//       headers: {
//         'Accept': 'application/json'
//       },
//       cache: 'no-store'
//     });

//     return await response.json();
//   }

//   /**
//    * Calculate subtotal excluding the free gift itself
//    */
//   function getQualifyingSubtotal(cart) {
//     return cart.items.reduce((total, item) => {
//       if (Number(item.variant_id) === Number(GIFT_VARIANT_ID)) {
//         return total;
//       }

//       return total + item.line_price;
//     }, 0);
//   }

//   /**
//    * Find the free gift in cart
//    */
//   function getGiftItem(cart) {
//     return cart.items.find(
//       item => Number(item.variant_id) === Number(GIFT_VARIANT_ID)
//     );
//   }

//   /**
//    * Add free gift
//    *
//    * IMPORTANT:
//    * Double-check the cart immediately before adding.
//    */
//   async function addGift() {
//     if (addingGift) {
//       console.log('[Free Gift] Add already in progress. Skipping.');
//       return;
//     }

//     addingGift = true;

//     try {
//       /*
//        * IMPORTANT:
//        * Fetch the latest cart before adding.
//        * This prevents duplicate gifts when multiple
//        * sync calls happen almost simultaneously.
//        */
//       const latestCart = await getCart();
//       const existingGift = getGiftItem(latestCart);

//       if (existingGift) {
//         console.log('[Free Gift] Gift already exists. Not adding another.');
//         return;
//       }

//       console.log('[Free Gift] Adding gift...');

//       await fetch('/cart/add.js', {
//         method: 'POST',
//         headers: {
//           'Content-Type': 'application/json',
//           'Accept': 'application/json'
//         },
//         body: JSON.stringify({
//           items: [
//             {
//               id: GIFT_VARIANT_ID,
//               quantity: 1
//             }
//           ]
//         })
//       });

//     } catch (error) {
//       console.error('[Free Gift] Add gift error:', error);
//     } finally {
//       addingGift = false;
//     }
//   }

//   /**
//    * Remove free gift
//    */
//   async function removeGift(giftItem) {
//     if (!giftItem) return;

//     console.log('[Free Gift] Removing gift...');

//     await fetch('/cart/change.js', {
//       method: 'POST',
//       headers: {
//         'Content-Type': 'application/json',
//         'Accept': 'application/json'
//       },
//       body: JSON.stringify({
//         id: giftItem.key,
//         quantity: 0
//       })
//     });
//   }

//   /**
//    * Main gift logic
//    */
//   async function syncFreeGift() {
//     if (syncingGift) return;

//     syncingGift = true;

//     try {
//       const cart = await getCart();

//       const qualifyingSubtotal = getQualifyingSubtotal(cart);
//       const giftItem = getGiftItem(cart);

//       console.log(
//         '[Free Gift]',
//         'Qualifying subtotal:',
//         qualifyingSubtotal / 100,
//         'Gift:',
//         giftItem ? `Yes (${giftItem.quantity})` : 'No'
//       );

//       /*
//        * ₹1499 OR MORE
//        * Gift should exist
//        */
//       if (qualifyingSubtotal >= THRESHOLD) {

//         if (!giftItem) {

//           /*
//            * addGift() performs another fresh cart check
//            * before actually adding the gift.
//            */
//           await addGift();

//           document.dispatchEvent(
//             new CustomEvent('cart:refresh')
//           );

//         } else if (giftItem.quantity !== 1) {

//           /*
//            * Always keep only 1 free gift
//            */
//           console.log('[Free Gift] Correcting gift quantity to 1...');

//           await fetch('/cart/change.js', {
//             method: 'POST',
//             headers: {
//               'Content-Type': 'application/json',
//               'Accept': 'application/json'
//             },
//             body: JSON.stringify({
//               id: giftItem.key,
//               quantity: 1
//             })
//           });

//           document.dispatchEvent(
//             new CustomEvent('cart:refresh')
//           );
//         }

//       /*
//        * BELOW ₹1499
//        * Gift should NOT exist
//        */
//       } else {

//         if (giftItem) {
//           await removeGift(giftItem);

//           document.dispatchEvent(
//             new CustomEvent('cart:refresh')
//           );
//         }
//       }

//     } catch (error) {
//       console.error('[Free Gift] Error:', error);
//     } finally {
//       syncingGift = false;
//     }
//   }

//   /**
//    * Debounce sync
//    */
//   function scheduleGiftSync() {
//     clearTimeout(syncTimeout);

//     syncTimeout = setTimeout(() => {
//       syncFreeGift();
//     }, 300);
//   }

//   /**
//    * Initial check
//    */
//   document.addEventListener('DOMContentLoaded', function () {
//     syncFreeGift();
//   });

//   /**
//    * Detect quantity changes
//    */
//   document.addEventListener('change', function (event) {

//     const target = event.target;

//     if (
//       target.matches(
//         'input[name="updates[]"], input.quantity__input, input.quantity, input[type="number"]'
//       )
//     ) {
//       scheduleGiftSync();
//     }
//   });

//   /**
//    * Detect plus/minus quantity buttons
//    */
//   document.addEventListener('click', function (event) {

//     const button = event.target.closest(
//       '[name="plus"], [name="minus"], .quantity__button, .quantity-button, button[data-quantity]'
//     );

//     if (button) {
//       scheduleGiftSync();
//     }
//   });

//   /**
//    * Shopify/theme cart events
//    */
//   [
//     'cart:updated',
//     'cart:refresh',
//     'cart:update',
//     'ajaxProduct:added',
//     'product:added'
//   ].forEach(eventName => {
//     document.addEventListener(eventName, function () {
//       scheduleGiftSync();
//     });
//   });

//   /**
//    * Watch Shopify AJAX cart requests
//    */
//   const originalFetch = window.fetch;

//   window.fetch = async function (...args) {

//     const response = await originalFetch.apply(this, args);

//     try {
//       const requestUrl = args[0]?.url || args[0];

//       if (
//         typeof requestUrl === 'string' &&
//         (
//           requestUrl.includes('/cart/add') ||
//           requestUrl.includes('/cart/change') ||
//           requestUrl.includes('/cart/update') ||
//           requestUrl.includes('/cart/clear')
//         )
//       ) {
//         setTimeout(() => {
//           scheduleGiftSync();
//         }, 400);
//       }

//     } catch (error) {
//       console.warn('[Free Gift] Fetch listener error:', error);
//     }

//     return response;
//   };

//   /**
//    * Safety check
//    */
//   setInterval(function () {
//     scheduleGiftSync();
//   }, 2000);

// })();

// FREE GIFT CAP OFFER ENDS